import React from 'react';
export var EditOrReadOnlyContext = /*#__PURE__*/React.createContext({
  mode: 'edit'
});